import React, { useState, useEffect } from 'react';
import './WelcomeScreen.css';

const WelcomeScreen = ({ onComplete }) => {
  const welcomeText = "Welcome to the new era of your intelligence";
  const [displayedText, setDisplayedText] = useState('');
  const [isComplete, setIsComplete] = useState(false);
  
  // Effect to handle the letter-by-letter animation
  useEffect(() => {
    let currentIndex = 0;
    let animationText = '';
    
    const textInterval = setInterval(() => {
      if (currentIndex < welcomeText.length) {
        animationText = welcomeText.substring(0, currentIndex + 1);
        setDisplayedText(animationText);
        currentIndex++;
      } else {
        clearInterval(textInterval);
        setIsComplete(true);
      }
    }, 70); // Speed of letter appearance (70ms per letter)
    
    return () => clearInterval(textInterval);
  }, []);
  
  // Effect to handle the display time after text is complete
  useEffect(() => {
    if (isComplete) {
      const displayTimer = setTimeout(() => {
        if (onComplete) {
          onComplete();
        }
      }, 7000); // 7 seconds display time
      
      return () => clearTimeout(displayTimer);
    }
  }, [isComplete, onComplete]);
  
  return (
    <div className="welcome-screen-overlay">
      <div className="welcome-screen">
        <div className="welcome-content">
          <h1 className="welcome-text">{displayedText}</h1>
          {isComplete && (
            <div className="welcome-animation">
              <div className="pulse-circle"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen; 